import type { SizeMixinInterface } from '../common/mixins/SizeMixin.js'

import { createContext } from '@lit/context'

export type InputGroupSize = SizeMixinInterface['size']

export interface InputGroupControlState {
  disabled: boolean
  readonly: boolean
  required: boolean
  invalid: boolean
  focusVisible: boolean
}

export interface InputGroupPresentationContextValue {
  /** Stable identity used when a provider republishes changed presentation state. */
  owner: object
  /** Group-level state layered onto the control's own public properties. */
  size: InputGroupSize
  required: boolean
  readonly: boolean
  /** Logical add-on presence used by the control to reduce only its seam-side padding. */
  hasInlineStartAddon: boolean
  hasInlineEndAddon: boolean
  registerControl: (control: HTMLElement, state: InputGroupControlState) => void
  updateControl: (control: HTMLElement, state: InputGroupControlState) => void
  unregisterControl: (control: HTMLElement) => void
}

/** Private context shared only by Input Group and supported Nord text controls. */
export const inputGroupPresentationContext = createContext<InputGroupPresentationContextValue | undefined>(
  Symbol('nord-input-group-presentation-context'),
)

/** Internal hook used when a server-rendered control upgrades before its group provider. */
export const requestInputGroupContext = Symbol('nord-input-group-context-request')
